module.exports = __webpack_public_path__ + "static/media/cv.03506a15.svg";